import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HistoricalPerformanceChartV2 } from "shared/Chart/HistoricalPerformanceChart/v2/index";
import {
  getHpLineColors,
  getHpFilteredDataWithTimeframe,
  stripBenchmarkFromHpData,
} from "features/Strategy/utils";
import { useStrategyDetails } from "features/Strategy/hook/useStrategyDetails";

const StrategyChart = ({ strategyId, isPublic = false }) => {
  const [chartLineColors, setChartLineColors] = useState([]);
  const [activeHpFilter, setActiveHpFilter] = useState("Max");
  const [hPerformance, setHPerformance] = useState({});

  const { data: strategyDetailData, isLoading: isDetailsLoading } =
    useStrategyDetails(strategyId, isPublic);

  useEffect(() => {
    if (strategyDetailData?.overview_chart) {
      // Process the API data using the same utilities as StrategyDetail
      const processedData = getHpFilteredDataWithTimeframe(
        strategyDetailData.overview_chart
      );
      const processedDataWithoutBenchmark =
        stripBenchmarkFromHpData(processedData);
      setHPerformance(processedDataWithoutBenchmark);

      // Generate chart line colors based on the current filter data
      if (
        processedDataWithoutBenchmark &&
        processedDataWithoutBenchmark[activeHpFilter]
      ) {
        const lineColors = getHpLineColors(
          processedDataWithoutBenchmark[activeHpFilter],
          false
        );
        setChartLineColors(lineColors);
      }
    }
  }, [strategyDetailData?.overview_chart, activeHpFilter]);

  const handleFilterClick = (filterId) => {
    setActiveHpFilter(filterId);
  };

  return (
    <HistoricalPerformanceChartV2
      height="300px"
      data={hPerformance[activeHpFilter] || []}
      lines={chartLineColors}
      activePeriod={activeHpFilter}
      handleFilterClick={handleFilterClick}
      timeframe={["3M", "YTD", "1Y", "3Y", "5Y", "Max"]}
      isLoading={isDetailsLoading}
      showLegend={false}
      showHeading={false}
      showTopTooltipProfit={false}
    />
  );
};

StrategyChart.propTypes = {
  strategyId: PropTypes.string.isRequired,
  isPublic: PropTypes.bool,
};

export default StrategyChart;
